import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';

const StyledText = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: -0.5px;
  color: ${tokens.ColorGrey900};
  margin: 32px 0 24px;
  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 22px;
    color: ${tokens.ColorGrey800};
    margin: 24px 0 0;
  }
`;

const StyledList = styled.ul`
  list-style: disc;
  margin-left: 24px;
`;

class ContributionSourceModal extends Component<any, any> {
  render(): JSX.Element {
    const {
      contribution: {
        tempScenario: { contributions },
      },
    } = this.props;

    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Contribution Source'} showClose={true} />
        <ReactModalContent>
          <StyledText>
            Future contributions to the following bonus source(s) will be omitted from our projections and estimates,
            however, the bonus source balances will be included:
          </StyledText>
          <StyledList>
            {contributions.map((account: any, accountIndex: number) => {
              return (
                <React.Fragment key={accountIndex}>
                  {account.contribution &&
                    account.contribution.map((contribution: any, contributionIndex: number) => {
                      return (
                        <React.Fragment key={contributionIndex}>
                          {contribution.inputType === 'B' && <li>{contribution.sourceName}</li>}
                        </React.Fragment>
                      );
                    })}
                </React.Fragment>
              );
            })}
          </StyledList>
        </ReactModalContent>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  const { contribution } = state;

  return {
    contribution,
  };
};

export default connect(mapStateToProps)(ContributionSourceModal);
